import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './styles/solution.css';
import Fade from 'react-reveal/Fade';
import Slide from 'react-reveal/Slide';
import { Helmet } from 'react-helmet';

const Solution = () => {
    return (
        <div className="Solution">
                <Helmet>
                    <title>{ "PASADA | Solution" }</title>
                    <meta name="description" content="PASADA PH Web Application" />
                </Helmet>
            <div className="containersolution">
            <div className="solutionarti d-flex justify-content-center align-items-center p-1"
                 style={{margin: "4rem"}}>
                <div class="solcon">
                    <Fade big>
                        <h1>SOLUTION</h1>
                        <p>The collaborative research of the Department of Science and Technology (DOST) together with
                            the Technological Institute of the Philippines (TIP) and National Public Transport Coalition
                            (NPTC) aims to enhance the skill and evaluate Filipino bus and public utility jeepney
                            drivers by developing software and hardware solutions, the PASADA project.
                        </p>
                        <p>The PASADA project, led by the Department of Science and Technology (DOST), the Technological
                            Institute of the Philippines (TIP), and National Public Transport Coalition (NPTC), has
                            officially signed a research collaboration agreement to develop software and hardware
                            solutions to evaluate Filipino bus and public utility jeepney driver competency and skills
                            using IoT.
                        </p>
                    </Fade>
                </div>
                <div>
                    <Fade big>
                        <img src={require('./images/solimg/solution.png')} alt="LOGO" className="simages"/>
                    </Fade>
                </div>
            </div>
            </div>

            <div className="container">
                <div className="row gx-1">
                    <Slide left>
                        <div className="col-sm-6 col-md-4">
                            <div className="card border-0 p-5 my-2">
                                <img src={require('./images/solimg/data-collection.png')} alt="Imagess" height="70"
                                     width="70" className="mb-2"/>
                                <div className="card-body">
                                    <h5>Data Collection</h5>
                                    <p>Gather and record data using IoT devices integrated in buses and public
                                        jeepneys.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="card border-0 p-5 my-2">
                                <img src={require('./images/solimg/data-analytics.png')} alt="Imagess" height="70"
                                     width="70" className="mb-2"/>
                                <div className="card-body">
                                    <h5>Data Analytics</h5>
                                    <p>Monitor, assess, and evaluate driving attitude while on the road.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="card border-0 p-5 my-2">
                                <img src={require('./images/solimg/machine-learning.png')} alt="Imagess" height="70"
                                     width="70" className="mb-2"/>
                                <div className="card-body">
                                    <h5>Machine Learning</h5>
                                    <p>Identify patterns and relationships in driver's behavior on the road.</p>
                                </div>
                            </div>
                        </div>
                    </Slide>
                    <Slide left>
                        <div className="col-sm-6 col-md-4">
                            <div className="card border-0 p-5 my-2">
                                <img src={require('./images/solimg/learning.png')} alt="Imagess" height="70" width="70"
                                     className="mb-2"/>
                                <div className="card-body">
                                    <h5>Learning Tools</h5>
                                    <p>Provide learning modules and assessment tasks for continuous driver
                                        education.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-md-4">
                            <div className="card border-0 p-5 my-2">
                                <img src={require('./images/solimg/dashboard.png')} alt="Imagess" height="70" width="70"
                                     className="mb-2"/>
                                <div className="card-body">
                                    <h5>Unified Management</h5>
                                    <p>Manage content, drivers, operators, and reports in one expansive application.</p>
                                </div>
                            </div>
                        </div>
                    </Slide>
                </div>
            </div>

            <div className="bencontainer d-flex flex-column justify-content-center align-items-center">
                <Slide bottom><h1 className="text-uppercase text-dark mb-4 mt-4">Benefits of Pasada</h1></Slide>
                <Slide bottom>
                    <div className="benwrapper d-flex justify-content-center align-items-center mb-5">
                        <div className="card bg-white d-flex flex-column align-items-center">
                            <img src={require('./images/solimg/driver.png')} alt="Driver" className="techimg"/>
                            <h2>Professionalize the Bus and PUJ Driving Job</h2>
                        </div>
                        <div className="card bg-white d-flex flex-column align-items-center">
                            <img src={require('./images/solimg/economy.png')} alt="Economy" className="techimg"/>
                            <h2>Boost Economy</h2>
                        </div>
                        <div className="card bg-white d-flex flex-column align-items-center">
                            <img src={require('./images/solimg/road.png')} alt="Road" className="techimg"/>
                            <h2>Promote Safer Roads</h2>
                        </div>
                        <div className="card bg-white d-flex flex-column align-items-center">
                            <img src={require('./images/solimg/puv.png')} alt="PUV" className="techimg"/>
                            <h2>Can Be Adapted by PUVs</h2>
                        </div>
                    </div>
                </Slide>
            </div>
        </div>
    );
}

export default Solution;